module.exports = {"svg":{"$":{"t":"1531214137108","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"3566","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M864 128H160c-17.6 0-32 14.4-32 32v704c0 17.6 14.4 32 32 32h704c17.6 0 32-14.4 32-32V160c0-17.6-14.4-32-32-32zM448 418.4l128 128 209.6-209.6 45.6 45.6L576 637.6l-128-128-81.6 80.8-45.6-45.6L448 418.4z m384 413.6H192V192h64v576h576v64z","p-id":"3567"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/picture.svg
// module id = PLea
// module chunks = 15